
import { API, API_GET_ID } from '../../Config'

export const GetHomePagelinksid = (id) => {
    
  return (
    API_GET_ID(API.HomepageLinksid,id)
  )
}

